import angular from 'angular';
import homeComponent from './home.component';
import HomeService from './home.service';
import homeConfig from './home.config';
import BrandsModule from './brands/brands';
import MenuModule from './menu/menu';

let homeModule = angular.module('home',[BrandsModule.name, MenuModule.name])
  .component('home', homeComponent)
  .service('HomeService', HomeService)
  .config(homeConfig);

export default homeModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/home/home.js
 **/